import { SingleMultiplePage as Page } from "apps/propertySelection/singleMultiple/Page";
import { criticalMark } from "libs/analytics/criticalMark";

export default criticalMark(Page, "SingleMultiplePage");
